<ng-container *transloco="let t">
  @if (hasData()) {
    <div class="transfer-card">
      <div class="transfer-card__header">
        <pxw-icon icon="billing" class="transfer-card__icon"></pxw-icon>
        <span class="transfer-card__title">{{ t('endOrder.transferPaymentInfo') }}</span>
      </div>
      <div class="transfer-card__body">
        @if (data().cvu; as cvu) {
          <div class="transfer-field transfer-field--stacked">
            <span class="transfer-field__label">{{ t('endOrder.transferCvuLabel') }}</span>
            <div class="transfer-field__row">
              <span class="transfer-field__value transfer-field__value--mono">{{ cvu }}</span>
              <button
                type="button"
                class="transfer-field__copy-btn"
                [class.transfer-field__copy-btn--copied]="copiedField() === 'cvu'"
                (click)="copyToClipboard(cvu, 'cvu')"
              >
                @if (copiedField() === 'cvu') {
                  <pxw-icon icon="check"></pxw-icon>
                } @else {
                  <pxw-icon icon="copy"></pxw-icon>
                }
              </button>
            </div>
          </div>
        }
        @if (data().alias; as alias) {
          <div class="transfer-field">
            <span class="transfer-field__label">{{ t('endOrder.transferAliasLabel') }}</span>
            <span class="transfer-field__value">{{ alias }}</span>
            <button
              type="button"
              class="transfer-field__copy-btn"
              [class.transfer-field__copy-btn--copied]="copiedField() === 'alias'"
              (click)="copyToClipboard(alias, 'alias')"
            >
              @if (copiedField() === 'alias') {
                <pxw-icon icon="check"></pxw-icon>
              } @else {
                <pxw-icon icon="copy"></pxw-icon>
              }
            </button>
          </div>
        }
        @if (data().accountHolder; as accountHolder) {
          <div class="transfer-field transfer-field--no-copy">
            <span class="transfer-field__label">{{ t('endOrder.transferAccountHolderLabel') }}</span>
            <span class="transfer-field__value">{{ accountHolder }}</span>
          </div>
        }
      </div>
    </div>
  }
</ng-container>
